import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/LegalDocument.css';

/*
 * LegalDocumentPage — shared scaffold for /privacy + /terms.
 *
 * Renders a live legal document: a title, an optional "Last updated" line,
 * and a list of { heading, body } sections. Deliberately dependency-light so
 * a content update is a pure data change — no framework / markdown wiring.
 *
 * NOTE: this page is linked from the iOS app (App Store Guideline 5.1.1
 * requires a functional privacy policy). Keep it free of "placeholder" /
 * "under review" framing — a reviewer opening /privacy must see real terms.
 */

const LegalDocumentPage = ({
  title,
  lastUpdated,
  sections = [],
  otherDocPath,
  otherDocLabel,
}) => (
  <div className="legal-page">
    <article className="legal-page__content">
      <header className="legal-page__header">
        <h1>{title}</h1>
        {lastUpdated && (
          <p className="legal-page__meta">Last updated: {lastUpdated}</p>
        )}
      </header>

      <div className="legal-page__sections">
        {sections.map(({ heading, body }) => (
          <section key={heading} className="legal-page__section">
            <h2>{heading}</h2>
            <p className="legal-page__body">{body}</p>
          </section>
        ))}
      </div>

      <footer className="legal-page__footer">
        {otherDocPath && (
          <Link to={otherDocPath}>{otherDocLabel}</Link>
        )}
        <Link to="/">Back to Matchup</Link>
      </footer>
    </article>
  </div>
);

export default LegalDocumentPage;
